/**
 * English Language Translations
 */

export default {
  uploadHistory: {
    title: 'CSV Upload History',
    subtitle: 'Track and monitor your data import history',

    // Actions
    back: 'Back',
    refresh: 'Refresh',
    search: 'Search',
    viewDetails: 'View Details',
    clearAll: 'Clear All',

    // Statistics
    stats: {
      totalUploads: 'Total Uploads',
      successful: 'Successful',
      partial: 'Partial Success',
      failed: 'Failed',
      items: 'items',
      ofTotal: 'of total',
    },

    // Filter Section
    filter: {
      title: 'Search and Filter',
      subtitle: 'Search and filter your upload history',
      searchPlaceholder: 'Filename, uploader, document number',
      status: 'Status',
      template: 'Template',
      date: 'Date',
      filterBy: 'Filter by:',
      clearFilters: 'Clear Filters',
    },

    // Table
    table: {
      title: 'Upload History List',
      showing: 'Showing',
      items: 'items',

      headers: {
        dateTime: 'Date/Time',
        uploadedBy: 'Uploaded By',
        file: 'File',
        template: 'Template',
        status: 'Status',
        counts: 'Counts',
        duration: 'Duration',
        actions: 'Actions',
      },
    },

    // Status
    status: {
      all: 'All',
      processing: 'Processing',
      completed: 'Completed',
      completedWithErrors: 'Completed with Errors',
      failed: 'Failed',
    },

    // Template
    template: {
      all: 'All',
      template1: 'Template 1',
      template2: 'Template 2',
    },

    // Empty State
    empty: {
      title: 'No Data Found',
      noData: 'No CSV upload history yet',
      noResults: 'No results match your search',
    },

    // Loading
    loading: {
      title: 'Loading Data',
      subtitle: 'Please wait...',
    },

    // Counts
    counts: {
      total: 'Total',
      items: 'items',
      success: 'Success',
      failed: 'Failed',
    },

    // Duration
    duration: {
      seconds: 'seconds',
    },

    // File Info
    file: {
      notAvailable: 'N/A',
      encoding: 'Encoding',
    },

    // Messages
    messages: {
      refreshSuccess: 'Data refreshed successfully',
      loadFailed: 'Failed to load upload history',
      reason: 'Reason',
      filterCleared: 'All filters cleared',
    },

    // Accessibility
    a11y: {
      backButton: 'Back to documents page',
      refreshButton: 'Refresh upload history data',
      searchField: 'Search upload history',
      statusFilter: 'Filter by status',
      templateFilter: 'Filter by template',
      dateFilter: 'Filter by date',
      viewDetailsButton: 'View upload details',
      closeDialog: 'Close dialog',
      clearFilter: 'Clear filter',
    },
  },
};
